import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class DirectorModification extends ShadowDOMElement {
	static className = "DirectorModification";
	
	static properties = {
		titleParting: {type: String, attribute: "title-parting"},
		textLabelParting : {title: String, attribute: "text-label-parting"},
		buttonLabelParting : {title: String, attribute: "button-label-parting"},
	};

	constructor() {
		super();
		this.titleParting = "Directeur";
		this.textLabelParting = "Directeur partant *";
		this.buttonLabelParting = "Ajouter un directeur partant";
		
		this.remplacementPersonnePhysique = false;
		this.remplacementSociete = false;
		this.nominationPersonnePhysique = false;
		this.nominationSociete = false;
		this.depart = false;
	}

	render() {
    return html`
      <div>
        <title-field label="${this.title}"></title-field>
        <subtitle-field label="Modifications :"></subtitle-field>

        <checkbox-field
          label="Remplacement d'une personne physique"
          id="chkRemplacementPersonnePhysique"
		  checked="${this.remplacementPersonnePhysique}"
          @change="${this.handleCheckboxChange}"
        ></checkbox-field>
        <div-container id="personnePhysiqueModificationList" visible="false">
          <personne-physique-director-modification-list
            label-add-button="Ajouter un directeur"
            title="${this.title}"
          ></personne-physique-modification-list>
        </div-container>

        <checkbox-field
          label="Remplacement d'une société"
          id="chkRemplacementSociete"
		  checked="${this.remplacementSociete}"
          @change="${this.handleCheckboxChange}"
        ></checkbox-field>
        <div-container id="personneMoraleModificationList" visible="false">
          <personne-morale-director-modification-list
            label-add-button="Ajouter un directeur"
            title="${this.title}"
            show-replacement="true"
          ></personne-morale-director-modification-list>
        </div-container>

        <checkbox-field
          label="Nomination d'une personne physique"
          id="chkNominationPersonnePhysique"
		  checked="${this.nominationPersonnePhysique}"
          @change="${this.handleCheckboxChange}"
        ></checkbox-field>
        <div-container id="personnePhysiqueList" visible="false">
          <personne-physique-director-list
            label-add-button="Ajouter un directeur"
            title="${this.title}"
          ></personne-physique-director-list>
        </div-container>

        <checkbox-field
          label="Nomination d'une société"
          id="chkNominationSociete"
		  checked="${this.nominationSociete}"
          @change="${this.handleCheckboxChange}"
        ></checkbox-field>
        <div-container id="personneMoraleList" visible="false">
          <personne-morale-director-list
            label-add-button="Ajouter un directeur"
            title="${this.title}"
            show-replacement="false"
          ></personne-morale-director-list>
        </div-container>

        <checkbox-field
          label="Départ"
          id="chkDepart"
		  checked="${this.depart}"
          @change="${this.handleCheckboxChange}"
        ></checkbox-field>
        <div-container id="directorPartingList" visible="false">
          	<director-parting-list
				title="${this.titleParting}"
				text-label="${this.textLabelParting}"
				button-label="${this.buttonLabelParting}"></director-parting-list>
        </div-container>
      </div>
    `;
  }

	handleCheckboxChange(event) {
		const checkboxId = event.target.id;
		const containerMap = {
			chkRemplacementPersonnePhysique: "personnePhysiqueModificationList",
			chkRemplacementSociete: "personneMoraleModificationList",
			chkNominationPersonnePhysique: "personnePhysiqueList",
			chkNominationSociete: "personneMoraleList",
			chkDepart: "directorPartingList",
		};

		const propertyMap = {
			chkRemplacementPersonnePhysique: "remplacementPersonnePhysique",
			chkRemplacementSociete: "remplacementSociete",
			chkNominationPersonnePhysique: "nominationPersonnePhysique",
			chkNominationSociete: "nominationSociete",
			chkDepart: "depart",
		};

		const checked = event.target.checked;
		this[propertyMap[checkboxId]] = checked;

		const containerId = containerMap[checkboxId];
		const container = this.shadowRoot.querySelector(`#${containerId}`);
		if (container)
			container.visible = checked;

		// If the checkbox is checked, remove all existing validation messages
		if (checked) {
			this.shadowRoot.querySelectorAll('div[data-validation-for]').forEach(el => el.remove());
		}
	}

	firstUpdated() {
		this.updateContainers();
	}

	updateContainers() {
		const propertyMap = {
			"remplacementPersonnePhysique": "personnePhysiqueModificationList",
			"remplacementSociete": "personneMoraleModificationList",
			"nominationPersonnePhysique": "personnePhysiqueList",
			"nominationSociete": "personneMoraleList",
			"depart": "directorPartingList",
		};

		for (const property in propertyMap) {
			const containerId = propertyMap[property];
			this.shadowRoot.querySelector(`#${containerId}`).visible = this[property];
		}
	}
	
	isTransient (){
		return false;
	}
	
	getValues (){
		return {
			"remplacementPersonnePhysique" : this.remplacementPersonnePhysique,
			"remplacementSociete" : this.remplacementSociete,
			"nominationPersonnePhysique" : this.nominationPersonnePhysique,
			"nominationSociete" : this.nominationSociete,
			"depart" : this.depart,
			... super.getValues ()
		}
	}

	setValues (values){
		this.remplacementPersonnePhysique = values.remplacementPersonnePhysique;
		this.remplacementSociete = values.remplacementSociete;
		this.nominationPersonnePhysique = values.nominationPersonnePhysique;
		this.nominationSociete = values.nominationSociete;
		this.depart = values.depart;
		this.requestUpdate ();
		this.updateContainers ();
		super.setValues (values);
	}
	
	// Validation: show messages for each checkbox if none checked; return false in that case.
	validate() {
		const checkboxes = this.shadowRoot.querySelectorAll('checkbox-field');

		// remove all existing validation messages first
		this.shadowRoot.querySelectorAll('div[data-validation-for]').forEach(el => el.remove());

		// if any checkbox is checked -> valid
		const anyChecked = Array.from(checkboxes).some(cb => !!cb.checked);
		if (anyChecked) {
			return true;
		}

		// none checked: show message for each checkbox and return false
		checkboxes.forEach(cb => {
			const id = cb.id || cb.getAttribute('id') || '';

			const row = document.createElement('div');
			row.className = 'row align-items-center';
			row.setAttribute('data-validation-for', id);

			const colLeft = document.createElement('div');
			colLeft.className = 'col-sm-3';

			const colRight = document.createElement('div');
			colRight.className = 'col-sm-9 text-danger d-flex align-items-center';
			colRight.style.paddingBottom = '0.25rem';
			colRight.style.paddingLeft = '0px';
			colRight.style.paddingBottom = ''; // ensure none

			const icon = document.createElement('i');
			icon.className = 'fa-solid fa-circle-exclamation me-2';
			icon.setAttribute('aria-hidden', 'true');

			const text = document.createElement('span');
			text.textContent = 'Vous devez cocher au moins une modification';

			colRight.appendChild(icon);
			colRight.appendChild(text);

			row.appendChild(colLeft);
			row.appendChild(colRight);

			if (cb.parentNode) cb.parentNode.insertBefore(row, cb.nextSibling);
		});

		return false;
	}
}

customElements.define("director-modification", DirectorModification);
